import { z } from "zod";
export const BotRecordingSchema = z.object({
    id: z.string(),
    status: z.string(),
    started_at: z.string().optional(),
});
export const BotMeetingParticipantSchema = z.object({
    id: z.string(),
    source: z.string(),
    name: z.string(),
    email: z.string(),
});
// NOTE: This is a simplified bot schema - the full RecallBot is in recall.ts
export const SimpleBotSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    status: z.string(),
    meeting_url: z.any().optional(),
    meeting_participants: z.array(BotMeetingParticipantSchema).optional(),
    recordings: z.array(BotRecordingSchema).optional(),
});
// Bot log event schema
export const BotLogEventSchema = z.object({
    event: z.enum(["bot.log", "bot.output_log"]),
    data: z.object({
        bot_id: z.string().optional(),
        job_id: z.string().optional(),
        log: z.object({
            level: z.string(),
            message: z.string(),
            output_id: z.string().nullable(),
            created_at: z.string(),
        }),
    }),
});
